/// <amd-module name="WorkItemsHub/Components/Cells/WorkItemDateTimeCell" />
import { localeDateFormat } from "VSS/Platform/Date";
import * as TooltipEx from "VSSUI/TooltipEx";
import * as React from "react";
import * as Utils_String from "VSS/Core/Util/String";

export interface IDateTimeCellOptions {
    /**
     * Optional format string for the content (e.g. "Updated {0}" will translate to "Updated 2 hours ago")
     */
    contentFormat?: string;

    /**
     * Date and time to be displayed
     */
    dateTime: Date;

    /**
     * Show the friendly version of date time (on by default, set to false to turn off)
     */
    showFriendlyDateTime?: boolean;

    /**
     * The start date and time used to calculate the relative friendly date from
     */
    friendlyStartDateTime?: Date;
}

export function createWorkItemDateTimeCell(options: IDateTimeCellOptions): JSX.Element {
    const {
        dateTime,
        contentFormat = "{0}"
    } = options;
    const dateFormat = new Intl.DateTimeFormat(undefined, {year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric", second: "numeric"});
    const tooltip: string = localeDateFormat(dateTime, "G", dateFormat).replace(",", "");
    const content: string = tooltip;

    return (
        <TooltipEx.Tooltip text={tooltip} overflowOnly={true}>
            <span className="work-item-date-time-cell">{Utils_String.format(contentFormat, content)}</span>
        </TooltipEx.Tooltip>
    );
}
